import React, { Component } from 'react';
import styled from 'styled-components';
import {Button} from '../../components/Button';

const Foot = styled.div`
  display: flex;
  justify-content: center;
  width: 100vw;
  font-size: 12px;
  background-color: #262237;
  border-bottom: 1px solid rgba(0, 0, 0, 0.0975);
  font-family:'panton-extrabold';
  color: white;
  position: absolute;
  bottom: 0;
  /* width: 100%; */
  /* height: 2.5rem;   */
`;
const FootMain = styled.div`
  width: 100%;
  margin: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const FootLeft = styled.div`
  width: 20%;
  text-align: left;
  display: flex;
  flex-direction: column;
`;
const FootCenter = styled.div`
  width: 20%;
  display: flex;
  text-align: left;
  flex-direction: column;
`;
const Input = styled.input`
  border: solid 1px #dbdbdb;
  border-radius: 3px;
  color: #262626;
  background-color: #262237;
  border-radius: 3px;
  color: #999;
  cursor: text;
  font-family:'panton-extrabold';
  font-size: 14px;
  font-weight: 300;
  text-align: left;
  background: #fafafa;
  width: auto;
  &:active,
  &:focus {
    text-align: left;
  }
`;

// const Button = styled.button`

// `;

const FootRight = styled.div`
  width: 20%;
  text-align: right;
  svg {
    margin-right: 20px;
  }
  display: flex;
  flex-direction: column;
`;
const MenuLink = styled.a`
text-decoration: none;
color: white;
`;


export default class Footer extends Component {
  render() {
    return (
      <Foot>
        <FootMain >
          <FootLeft>
            <MenuLink >Acerca de nosotros</MenuLink>
            <MenuLink >Contacto</MenuLink>
            <MenuLink >Términos y condiciones</MenuLink>
          </FootLeft>
          <FootCenter> 
            <div>
            <MenuLink>Facebook</MenuLink>
            </div>
            <div>
            <MenuLink>Twitter</MenuLink>
            </div>
            <div>
            <MenuLink>Instagram</MenuLink>
            </div>
          </FootCenter>
          <FootCenter>
            <h4>Suscríbete a nuestro newsletter</h4>
            <div >
              <Input placeholder="Correo electrónico"/>
              <Button auth>Enviar</Button>
            </div>
          </FootCenter>
          <FootRight>
            <MenuLink>Sevilla 40, 06600, CDMX</MenuLink>
            <MenuLink>+52 1 55 2844 2452</MenuLink>
            <MenuLink>hola@smartia.com</MenuLink>
          </FootRight>
        </FootMain>
      </Foot>
    )
  }
}
